import { render, staticRenderFns } from "./relationType.vue?vue&type=template&id=32a1528a&"
import script from "./relationType.vue?vue&type=script&lang=js&"
export * from "./relationType.vue?vue&type=script&lang=js&"
import style0 from "./relationType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32a1528a')) {
      api.createRecord('32a1528a', component.options)
    } else {
      api.reload('32a1528a', component.options)
    }
    module.hot.accept("./relationType.vue?vue&type=template&id=32a1528a&", function () {
      api.rerender('32a1528a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aymentsdk/relationType.vue"
export default component.exports